import MatchWeek from "../models/MatchWeek";

export const MatchSchedule2026: MatchWeek[] = [
    {
        champDraftWeek: 1,
        lowerDraftWeek: 1,
        matchday: 1,
        endDate: new Date("2026-02-22")
    },
    {
        champDraftWeek: 2,
        lowerDraftWeek: 2,
        matchday: 2,
        endDate: new Date("2026-03-01")
    },
    {
        champDraftWeek: 3,
        lowerDraftWeek: 3,
        matchday: 3,
        endDate: new Date("2026-03-08")
    },
    {
        champDraftWeek: 4,
        lowerDraftWeek: 4,
        matchday: 4,
        endDate: new Date("2026-03-15")
    },
    {
        champDraftWeek: 5,
        lowerDraftWeek: 5,
        matchday: 6,
        endDate: new Date("2026-04-05")
    },
    {
        champDraftWeek: 6,
        lowerDraftWeek: 6,
        matchday: 7,
        endDate: new Date("2026-04-12")
    },
    {
        champDraftWeek: 7,
        lowerDraftWeek: 7,
        matchday: 8,
        endDate: new Date("2026-04-19")
    },
    {
        champDraftWeek: 8,
        lowerDraftWeek: 8,
        matchday: 9,
        endDate: new Date("2026-04-26")
    },
    {
        champDraftWeek: 9,
        lowerDraftWeek: 9,
        matchday: 10,
        endDate: new Date("2026-05-03")
    },
    {
        champDraftWeek: 10,
        lowerDraftWeek: 10,
        matchday: 11,
        endDate: new Date("2026-05-10")
    },
    {
        champDraftWeek: 11,
        lowerDraftWeek: 11,
        matchday: 12,
        endDate: new Date("2026-05-17")
    },
    {
        champDraftWeek: 12,
        lowerDraftWeek: null,
        matchday: 13,
        endDate: new Date("2026-05-24")
    },
    {
        champDraftWeek: 13,
        lowerDraftWeek: 12,
        matchday: 15,
        endDate: new Date("2026-07-25")
    },
    {
        champDraftWeek: 14,
        lowerDraftWeek: 13,
        matchday: 16,
        endDate: new Date("2026-08-01")
    },
    {
        champDraftWeek: 15,
        lowerDraftWeek: null,
        matchday: 17,
        endDate: new Date("2026-08-16")
    },
    {
        champDraftWeek: 16,
        lowerDraftWeek: null,
        matchday: 18,
        endDate: new Date("2026-08-23")
    },
    {
        champDraftWeek: 17,
        lowerDraftWeek: null,
        matchday: 19,
        endDate: new Date("2026-08-30")
    },
    {
        champDraftWeek: 18,
        lowerDraftWeek: 14,
        matchday: 20,
        endDate: new Date("2026-09-05")
    },
    {
        champDraftWeek: 19,
        lowerDraftWeek: 15,
        matchday: 21,
        endDate: new Date("2026-09-13")
    },
    {
        champDraftWeek: 20,
        lowerDraftWeek: 16,
        matchday: 22,
        endDate: new Date("2026-09-20")
    },
    {
        champDraftWeek: 21,
        lowerDraftWeek: 17,
        matchday: 24,
        endDate: new Date("2026-10-11")
    },
    {
        champDraftWeek: 22,
        lowerDraftWeek: 18,
        matchday: 25,
        endDate: new Date("2026-10-18")
    },
    {
        champDraftWeek: 23,
        lowerDraftWeek: 19,
        matchday: 26,
        endDate: new Date("2026-10-25")
    },
    {
        champDraftWeek: 24,
        lowerDraftWeek: 20,
        matchday: 27,
        endDate: new Date("2026-11-01")
    }
];